//src/components/assistant/tools/GenerateInteractiveDayPartTool.tsx
import React, { useRef } from "react";
import { makeAssistantToolUI } from "@assistant-ui/react";
import TimeSelectionEditDayPartTypeView, {
  TimeSelectionEditDayPartTypeViewHandle,
} from "../../time/TimeSelectionEditDayPartTypeView";
import { ProposedDate, SelectedDayPartPair } from "../../time/types";
import { convertJSONtoScheduleOptions } from '../../../service/playdate/converters/converter';

type Args = {
    proposedDates: any[];
    singleSelection?: boolean;
};

type Result = SelectedDayPartPair[];

const ToolUIComponent: React.FC<{
    args: Args;
    addResult: (result: Result) => void;
}> = ({ args, addResult }) => {
    const editorRef = useRef<TimeSelectionEditDayPartTypeViewHandle>(null);

    const initialSelections: SelectedDayPartPair[] = convertJSONtoScheduleOptions({
        scheduleOptions: args.proposedDates,
    });
    console.log("Initial selections converted:", initialSelections);

    return (
        <div className="p-4 border rounded shadow space-y-4">
            <h4 className="mb-2 font-bold">Choose Available Time(s)</h4>
            <TimeSelectionEditDayPartTypeView
                ref={editorRef}
                initialSelectedDayParts={initialSelections}
                onEditChange={() => {}}
                onExploreMore={() => {}}
            />
            <div className="flex justify-end">
                <button
                    className="px-2 py-1 text-black bg-white rounded active:bg-gray-200"
                    onClick={() => {
                        const validated = editorRef.current?.validate();
                        if (validated?.isValid) {
                            addResult(validated.selected);
                            console.log("TEMPORARY: Submitted selections:", validated.selected);
                        }
                    }}
                    >
                    Submit
                </button>
            </div>
        </div>
    );
};

export const GenerateInteractiveDayPartTool = makeAssistantToolUI<Args, Result>({
    toolName: "GenerateInteractiveDayPartTool",
    render: ({ args, addResult }) => (
        <ToolUIComponent args={args} addResult={addResult} />
    ),
});
